module.exports = __webpack_public_path__ + "img/buffalo-milk.f3c72d91.jpg";